import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import axios from 'axios'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { SERVER_URI } from '../utility/config'

const containerStyle = {
  width: '100%',
  height: '400px',
}

const center = {
  lat: 61.489106,
  lng: 23.794148,
}

const mapOptions = {
  // Disable all controls except zoom
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  gestureHandling: "greedy",
  
  // Disable points of interest and transit
  styles: [
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    }
  ],
  
  // Increase/decrease the zoom level constraints if needed
  minZoom: 8,
  maxZoom: 18,
  
  // Restrict panning if needed
  // restriction: {
  //   latLngBounds: {
  //     north: 61.6,
  //     south: 61.3,
  //     east: 24.0,
  //     west: 23.6,
  //   },
  //   strictBounds: false,
  // }
}


export const CarMap = ({vehicles}) => {
  const [apiKey, setApiKey] = useState('')
  const userToken = localStorage.getItem('admin_token')

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const response = await axios.get(`${SERVER_URI}/get_google_api_key`, {
          headers: { Authorization: `Token ${userToken}` },
        })
        setApiKey(response.data.apiKey)
      } catch (e) {
        console.log('Error in getting api key', e)
      }
    }
    fetchApiKey()
  }, [userToken])

  if(!apiKey) {
    return <div>Loading...</div>
  }

  return <Map apiKey={apiKey} markers={vehicles} />
}

const Map = ({apiKey, markers}) => {
  const mapRef = useRef(null) 
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
  })

  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  if(!isLoaded) {
    return <div>Loading map...</div>
  }
  function CarPopoverOverlay(map, car) {
    this.map_ = map;
    this.car_ = car;
    this.div_ = null;
    this.setMap(map);
  }
  
  CarPopoverOverlay.prototype = new window.google.maps.OverlayView();
  
  CarPopoverOverlay.prototype.onAdd = function() {
    let div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.backgroundColor = 'white';
    div.style.border = '2px solid #ccc';
    div.style.padding = '5px';
    div.style.borderRadius = '5px';
    div.innerHTML = `<div>
    ${this.car_.isOnBreak ? "<h1>Tauolla</h1>" : ""}
    <h3>${this.car_.registerPlate}</h3>
    <h3>${this.car_.phoneNumber}</h3>
    <h2>${this.car_.driverName}</h2>
    </div>`;
    this.div_ = div;
  
    let panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
  };
  
  CarPopoverOverlay.prototype.draw = function() {
    let overlayProjection = this.getProjection();
    let sw = overlayProjection.fromLatLngToDivPixel(new window.google.maps.LatLng(parseFloat(this.car_.lat), parseFloat(this.car_.lon)));
  
    let div = this.div_;
    div.style.left = sw.x + 'px';
    div.style.top = sw.y + 'px';
  };
  
  CarPopoverOverlay.prototype.onRemove = function() {
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  };

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10} options={mapOptions} onLoad={onLoad}>
      {markers && markers.length > 0 && markers.map((car, index) => (
        (car.lat && car.lon) ? (
          <CarMarker key={index} car={car} mapRef={mapRef} CarPopoverOverlay={CarPopoverOverlay}/>
        ) : null
      ))}
    </GoogleMap>
  )
}

const CarMarker = ({car, mapRef, CarPopoverOverlay}) => {
  const markerRef = useRef(null);
  const overlayRef = useRef(null);

  const handlePopoverOpen = () => {
    if (markerRef.current && mapRef.current) {
      // Remove old overlay if exists
      if (overlayRef.current) {
        overlayRef.current.setMap(null);
      }

       // Create new overlay
       const newOverlay = new CarPopoverOverlay(mapRef.current, car);
       newOverlay.setMap(mapRef.current);
       overlayRef.current = newOverlay;
    }
  }

  const handlePopoverClose = () => {
    if (overlayRef.current) {
      overlayRef.current.setMap(null);
      overlayRef.current = null;
    }
  }
  
  const getIconUrl = (color) => {
    const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-car" xmlns:bx="https://boxy-svg.com">
        <path fill="${color}" d="M95 85h15c3 0 5-2 5-5v-15c0-4.5-3.5-8.5-7.5-9.5C93.5 53 80 50 80 50s-6.5-7-11-11.5c-2.5-2-5.5-3.5-9-3.5H25c-3 0-5.5 2-7 4.5l-7 14.5C9.5 58 8 62 10 66v15c0 3 2 5 5 5h10"/>
        <circle fill="black" cx="35" cy="85" r="10"/>
        <path fill="black" d="M45 85h30 L 60 115 L 45 85" style=""/>
        <circle fill="black" cx="85" cy="85" r="10"/>
      
        <!-- Fix text with proper spacing -->
        <text x="47" y="68" 
              font-size="20" 
              font-family="Arial, sans-serif" 
              text-anchor="middle" 
              fill="black"
              stroke-width="0" 
              font-weight="bold">${car.vehicleId}</text>
        </svg>
    `
    
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgString)}`;
  }

  return (
    <>
    <Marker 
      position={{
        lat: parseFloat(car.lat),
        lng: parseFloat(car.lon),
      }}
      icon={{
        url: getIconUrl(car.isDriving ? "red" : car.isOnBreak ? "blue" : "green"),
        scaledSize: new window.google.maps.Size(100, 100),
        //anchor: new window.google.maps.Point(18, 18),
        fillColor: "#000000",
      }}
      onMouseOver={handlePopoverOpen}
      onMouseOut={handlePopoverClose}
      onLoad={(marker) => {
        markerRef.current = marker;
      }}
    />
    <p>{car.registerPlate}</p>
    </>
  )
}

export default React.memo(CarMap)